module.exports = __webpack_public_path__ + "img/NATURGY_80X30.f13ec7b9.png";